import React from 'react'
import ButtonSend from '../Button/ButtonSend'
import ButtonDownload from '../Button/ButtonDownload'
import TableCellContainer from './TableCellContainer'
import {
  useDispatch
} from 'react-redux'
import {
  format_export
} from '../../../Functions/Dates'
import {
  SEND_EXPORT,
  DOWNLOAD_EXPORT
} from '../../../Redux/Actions/Comptabilite'

const TableCellActionsExports = ({ item }) => {
  const dispatch = useDispatch()
  return (
    <TableCellContainer width={2}>
      <ButtonDownload
        color="green"
        onClick={() => {
          dispatch(DOWNLOAD_EXPORT(
            item.id,
            format_export(item.debut) + '_' + format_export(item.fin)
          ))
        }}
      />
      <ButtonSend
        color="blue"
        onClick={() => {
          dispatch(SEND_EXPORT(item.id))
        }}
      />
    </TableCellContainer>
  )
}

export default TableCellActionsExports
